// extracted by mini-css-extract-plugin
module.exports = {"templateBlock":"TemplateBlock_templateBlock__2tXZk","blockHeader":"TemplateBlock_blockHeader__3-VwI","templateCardList":"TemplateBlock_templateCardList__1EPC6"};